import { useParams } from "react-router-dom";
import ScriptView from "./../components/ScriptView.react";

export default function ScriptViewRoute(): React$Element<any> {
  let params = useParams();
  return <ScriptView sessionId={params.sessionId} />;
}
